export default "/_next/static/chunks/bust-4-d.d2121863cb7fc4eff2a0804677318c3c.glb";